import { render } from "./DeveloperRow.vue?vue&type=template&id=41c93ff4"
import script from "./DeveloperRow.vue?vue&type=script&lang=js"
export * from "./DeveloperRow.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__